/* Copyright Epoq Legal Ltd 2009-2018 */

var Selector = (typeof Selector == "undefined") ? {} : Selector;

Selector.Collection = {};
Selector.Model = {};
Selector.View = {};

$(function(){
    ele.apps = ele.apps || {};
    ele.apps.SelectorApp = new Selector.View.AppView;
});